import { useQuery } from '@apollo/client/react';

import { logger } from '#utils/logging/logger';

import { PrivacyEmbedConsentServiceDocument } from './__generated__/PrivacyEmbedConsentTextFetcherHook.generated';

interface UsePrivacyEmbedConsentService {
	text: string | null;
	cmpServiceId: string | null | undefined;
	loading: boolean;
}

export function usePrivacyEmbedConsentService(service: string): UsePrivacyEmbedConsentService {
	const { data, error, loading } = useQuery(PrivacyEmbedConsentServiceDocument, {
		variables: { service },
	});

	const result: UsePrivacyEmbedConsentService = { loading, text: null, cmpServiceId: null };

	if (!loading) {
		if (error) {
			logger.error(`Error loading privacy embed consent service: %s`, error.message);
		}

		if (!data) {
			logger.error(`No data returned from 'PrivacyEmbedConsentServiceFetcher'.`);
		} else if (!data.embedService) {
			logger.error(`Embed Service not found: %s`, service);
		} else {
			const {
				embedService: { privacyText, cmpServiceId },
			} = data;

			if (privacyText) {
				result.text = privacyText;
				result.cmpServiceId = cmpServiceId;
			}
		}
	}

	return result;
}
